import React from 'react';
import PropTypes from 'prop-types';

import withGooglePlaces from 'dpl/decorators/withGooglePlaces';
import MobileLocationResultsList from 'dpl/search/components/MobileLocationResultsList';
import MobileLocationResultsListV2 from 'dpl/search/components/MobileLocationResultsListV2';

/** @param {Record<string, any>} props */
function MobileLocationResultsListContainer({ isNewLayout = false, ...rest }) {
  const props = { isNewLayout, ...rest };
  if (isNewLayout) {
    return <MobileLocationResultsListV2 {...props} />;
  }

  return <MobileLocationResultsList {...props} />;
}

MobileLocationResultsListContainer.propTypes = {
  isNewLayout: PropTypes.bool
};

export default withGooglePlaces(MobileLocationResultsListContainer);
